module.exports = __webpack_public_path__ + "img/bookmark.b9cbecfa.svg";